(function () {
  const header = document.querySelector('.ed-header');
  if (!header) return;
  let lastY = window.scrollY;
  let solidThreshold = window.innerHeight * 0.7;
  const onScroll = () => {
    const y = window.scrollY;
    const goingDown = y > lastY;
    header.dataset.hidden = (goingDown && y > 200).toString();
    header.dataset.solid = (y > solidThreshold).toString();
    lastY = y;
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => { solidThreshold = window.innerHeight * 0.7; });
  onScroll();
})();
